import styled from 'styled-components';

import { sizeStyles, StyledSizeProps } from '../../styles';
import { colors } from '../../theme';

type DividerProps = StyledSizeProps & {
  $color?: string;
};

export const VerticalDivider = styled.div<DividerProps>`
  align-self: stretch;
  width: 1px;
  flex: 1;
  min-width: 1px;
  max-width: 1px;
  min-height: 100%;
  background-color: ${({ $color = colors.sand }) => $color};
  ${sizeStyles}
`;

export const HorizontalDivider = styled.div<DividerProps>`
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;
  height: 1px;
  background-color: ${({ $color = colors.sand }) => $color};
  ${sizeStyles}
`;
